import BillUnit from './BillUnit';
import CreditCard from './CreditCard';

export enum BillMethod {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice',
}

const AVAILABLE_BILL_METHOD = Object.keys(BillMethod);

class BillUser {
  public readonly id?: string;
  public readonly kaizenUserId: string;
  public readonly billMethod: BillMethod;
  public readonly countryOfResidence: string;
  public readonly creditCard?: CreditCard;
  public readonly billUnits?: [BillUnit];
  public readonly creditFacility?: number;

  constructor({
    id,
    kaizenUserId,
    billMethod,
    countryOfResidence,
    creditCard,
    billUnits,
    creditFacility,
  }: {
    id?: string;
    kaizenUserId: string;
    billMethod?: BillMethod;
    countryOfResidence?: string;
    creditCard?: CreditCard;
    billUnits?: [BillUnit];
    creditFacility?: number;
  }) {
    this.id = id;
    this.kaizenUserId = kaizenUserId;
    this.billMethod = billMethod || BillMethod.CREDIT_CARD;
    this.countryOfResidence = countryOfResidence || 'JP';
    this.creditCard = creditCard;
    this.billUnits = billUnits;
    this.creditFacility = creditFacility;
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      kaizen_user_id,
      bill_method,
      country_of_residence,
      credit_cards,
      bill_units,
      credit_facility,
    } = Object.assign({}, value);
    const kaizenUserId = String(kaizen_user_id);
    const billMethod = bill_method.toUpperCase();
    const countryOfResidence = country_of_residence;
    const creditCard = credit_cards.find((c: any) => c.default);
    const creditFacility = Number(credit_facility);

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (typeof kaizenUserId !== 'string') throw new TypeError('.kaizenUserId must be a string');
    if (billMethod && !AVAILABLE_BILL_METHOD.includes(billMethod))
      throw new TypeError('.billMethod must be a valid action string');
    if (typeof creditFacility !== 'number') throw new TypeError('.creditFacility must be a number');

    return new BillUser({
      id: String(id),
      kaizenUserId,
      billMethod,
      countryOfResidence,
      creditCard: creditCard ? CreditCard.fromJSON(creditCard) : undefined,
      billUnits: bill_units.map((b: BillUnit) => BillUnit.fromJSON(b)),
      creditFacility,
    });
  };
}

export default BillUser;
